<template>
  <v-app id="inspire">
    <div class="cleanup-notifications-report-wrap">
      <v-layout class="mb-4">
        <v-flex>
          <p class="text-uppercase caption mb-0">Reports</p>
          <h2 class="headline">Cleanup Notifications Report</h2>
        </v-flex>
        <v-spacer></v-spacer>
        <!-- <v-btn
          class="mx-0 mb-0"
          text
          small
          :disabled="loading || items.length === 0"
          @click="exportCSV"
          ><v-icon class="mr-1">cloud_download</v-icon> CSV
        </v-btn> -->
      </v-layout>
      <div class="mb-7">
        <v-container container--fluid class="grid-list-md pa-0 mb-4">
          <v-layout class="wrap xs12">
            <v-flex class="xs12 sm6 md2" style="min-width: 200px;">
              <v-menu
                ref="menu1"
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="tableData.date"
                    label="Date"
                    prepend-icon="event"
                    readonly
                    placeholder="Please Select"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="tableData.date"
                  no-title
                  @input="menu1 = false"
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="xs12 sm6 md2" style="min-width: 200px;">
              <v-autocomplete
                :items="clientList"
                v-model="selectedClient"
                label="Client Name"
                item-text="title"
                :item-value="i => i"
                clearable
                :loading="loadingClients"
                placeholder="Please Select"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="xs12 sm6 md2" style="min-width: 100px;">
              <v-autocomplete
                :items="channels"
                v-model="tableData.chanel"
                label="Channel"
                item-text="text"
                item-value="value"
                clearable
                placeholder="Please Select"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="xs12 sm6 md2" style="min-width: 100px;">
              <v-autocomplete
                :items="types"
                v-model="tableData.type"
                label="Type"
                item-text="text"
                item-value="value"
                clearable
                placeholder="Please Select"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="xs12 sm6 md2" style="min-width: 100px;">
              <v-autocomplete
                :items="statuses"
                v-model="tableData.status"
                label="Status"
                item-text="text"
                item-value="value"
                clearable
                placeholder="Please Select"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="xs12 sm6 md2">
              <v-btn
                @click="initialize(1)"
                large
                color="#00838F"
                dark
                class="mx-0"
                style="min-width: 45px; padding: 0 8px;"
              >
                Go
              </v-btn>
              <v-btn
                @click="initialize(1)"
                large
                color="#f79b58"
                dark
                class="my-0 ml-1 mr-0"
                style="min-width: 45px; padding: 0 8px;"
              >
                <v-icon>autorenew</v-icon>
              </v-btn>
            </v-flex>
            <v-flex class="xs12 my-0">
              <span
                @click="resetFilters"
                class="clear-filters"
                >Reset Filters</span
              >
            </v-flex>
          </v-layout>
          <v-alert
            v-if="notificationsDisabled"
            type="error"
            class="mb-0 mt-2"
          >
            Disabled Default Notifications
          </v-alert>
        </v-container>
      </div>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          loader-height="2"
          :footer-props="{'items-per-page-options': [10, 20]}"
          class="elevation-1 table-org"
          :header-props="{ 'sort-icon': 'arrow_downward' }"
          mobile-breakpoint="100"
        >
          <template v-slot:item="{item}">
            <tr class="items-body-row">
              <td>
                <span v-if="!no_data.includes(item.updated_at)">{{ formatTime(item.updated_at) }}</span>
                <span v-else-if="!no_data.includes(item.created_at)">{{ formatTime(item.created_at) }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <v-layout v-if="
                  (!no_data.includes(item.client_id) &&
                    !no_data.includes(item.full_name)) ||
                  (!no_data.includes(item.commercial_client_id) &&
                    !no_data.includes(item.commercial_location_id) &&
                    !no_data.includes(item.full_name)
                  )"
                  style="margin-left: -14px;">
                  <v-menu offset-y bottom right d-inline-flex>
                    <template v-slot:activator="{ on }">
                      <v-btn class="ma-0" v-on="on" icon>
                        <v-icon color="#999">more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="pa-0">
                      <v-list-item
                        v-if="!no_data.includes(item.client_id)"
                        @click="
                          $router.push(
                            '/client/' + item.client_id + '/show'
                          )
                        "
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px"
                            >visibility</v-icon
                          >
                          View Client Details
                        </v-flex>
                      </v-list-item>
                      <v-list-item
                        v-else
                        @click="
                          $router.push(
                            `/commercial_client/${item.commercial_client_id}/show`
                          )
                        "
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px"
                            >visibility</v-icon
                          >
                          View Client Details
                        </v-flex>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-layout class="wrap align-center">
                    <v-flex>{{ item.full_name }}</v-flex>
                  </v-layout>
                </v-layout>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.chanel)">
                  <template v-if="channels.some(i => i.value === item.chanel)">
                    {{ channels.find(i => i.value === item.chanel).text }}
                  </template>
                  <template v-else>
                    {{ titleCase(item.chanel) }}
                  </template>
                </span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.type)">{{ titleCase(item.type) }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span
                  v-if="!no_data.includes(item.status)"
                  class="text-uppercase"
                  :style="`color: ${status_colors[item.status]}`"
                >{{ titleCase(item.status) }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr
              v-if="
                (
                  !no_data.includes(item.status) &&
                  ['failed', 'undelivered'].includes(item.status)
                ) &&
                (
                  !no_data.includes(item.meaning) ||
                  !no_data.includes(item.description)
                )
              "
              class="custom-row"
              style="border-bottom: 1px solid #ccc;"
            >
              <td colspan="100%" class="pa-0">
                <v-card flat class="rounded-0">
                  <v-card-text class="red lighten-5" style="padding: 10px 16px;">
                    <div style="position: relative;">
                      <v-icon
                        size="16px"
                        color="grey lighten-1"
                        style="position: absolute; top: 5px;"
                        >subdirectory_arrow_right</v-icon
                      >
                      <div
                        v-if="!no_data.includes(item.meaning)"
                        class="py-1"
                      >
                        <span class="error--text ml-6">Meaning: </span>
                        <span>{{ item.meaning }}</span>
                      </div>
                      <div
                        v-if="!no_data.includes(item.description)"
                        class="py-1"
                      >
                        <span class="error--text ml-6">Description: </span>
                        <span>{{ item.description }}</span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>
<script>
import ApiService from "@/common/api.service";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CleanupNotificationsReport",
  data: () => ({
    no_data: [null, "", undefined, "null"],
    menu1: false,
    items: [],
    loading: false,
    options: {},
    headers: [
      { text: "Time", value: "updated_at", sortable: false },
      { text: "Client Name", value: "client_name", sortable: false },
      { text: "Channel", value: "chanel", sortable: false },
      { text: "Type", value: "client_id", sortable: false },
      { text: "Status", value: "status", sortable: false }
    ],
    loadingClients: false,
    loadingResidentialClients: false,
    loadingCommercialClients: false,
    residentialClients: [],
    commercialClients: [],
    types: [
      {"text": "Off-Schedule", "value": "off_schedule"},
      {"text": "On the Way", "value": "on_the_way"},
      {"text": "Completed", "value": "completed"}
    ],
    channels: [
      {"text": "Email", "value": "email"},
      {"text": "Text", "value": "sms"},
      {"text": "Call", "value": "call"}
    ],
    statuses: [
      {"text": "Accepted", "value": "accepted"},
      {"text": "Delivered", "value": "delivered"},
      {"text": "Expired", "value": "expired"},
      {"text": "Failed", "value": "failed"},
      {"text": "Undelivered", "value": "undelivered"},
      {"text": "Sent", "value": "sent"}
    ],
    selectedClient: null,
    totalItems: 0,
    search: "",
    draw: 0,
    tableData: {
      date: moment().format("YYYY[-]MM[-]DD"),
      draw: 0,
      length: 10,
      search: "",
      page: 0,
      column: 0,
      dir: "asc"
    },
    status_colors: {
      accepted: '#2196f3',
      delivered: '#4CAF50',
      expired: '#9C27B0',
      failed: '#FF5252',
      undelivered: '#FF5252',
      sent: '#FFA500'
    },
    notificationsDisabled: false,
    loadingOrganizationSettings: false,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong..."
  }),
  mounted() {
    if (!this.no_data.includes(this.cleanupNotificationsReportTableData)) {
      this.options = this.cleanupNotificationsReportTableData.options
      this.tableData = this.cleanupNotificationsReportTableData.tableData
    }
    this.initialize();
    this.getClients();
    this.getOrganizationSettings(true)
  },
  watch: {
    options: {
      handler() {
        if (this.draw !== this.tableData.draw) {
          this.initialize();
        }
      },
      deep: true
    },
    search: _.debounce(function() {
      this.typing = false;
      if (this.draw !== this.tableData.draw) {
        this.initialize(1);
      }
    }, 1000)
  },
  methods: {
    ...mapActions(['setTableData', 'checkOrganizationSettings']),
    initialize(setPage) {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      this.tableData.column = 0;
      if (
        !this.no_data.includes(sortBy) &&
        !this.no_data.includes(sortBy[0]) &&
        this.headers.some(i => i.value === sortBy[0] && i.sortable !== false)
      ) {
        this.tableData.column = this.headers.find(
          i => i.value === sortBy[0]
        ).sort_column;
      }
      this.tableData.dir = !this.no_data.includes(sortDesc) && sortDesc[0] === true ? "asc" : "desc";

      this.tableData.length = itemsPerPage;

      this.tableData.page = page;
      this.tableData.search = this.search;
      this.tableData.draw++;
      this.draw = this.tableData.draw;

      if (!this.no_data.includes(this.selectedClient)) {
        if(this.selectedClient.type === 'residential') {
          this.tableData.client_id = this.selectedClient.id
        }
        if(this.selectedClient.type === 'commercial') {
          this.tableData.commercial_client_id = this.selectedClient.commercial_client_id
          this.tableData.commercial_location_id = this.selectedClient.commercial_location_id
        }
      }

      let filtersForSaving = { tableData: _.cloneDeep(this.tableData), options: _.cloneDeep(this.options)}
      filtersForSaving.tableData.draw = 0
      this.setTableData({key: 'cleanupNotificationsReportTableData', value: filtersForSaving})

      ApiService.get("/job_notification_organisation", this.tableData)
        .then(response => {
          this.draw++;
          let data = response.data.job_notifications
          this.items = data.data;
          this.totalItems = data.total;
          if (setPage) { this.options.page = setPage }
          this.loading = false;
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    getClients() {
      this.loadingClients = true
      Promise.all([
        this.getResidentialClients(),
        this.getCommercialClients()
      ])
      .then(responses => {
        this.loadingClients = false
      })
      .catch(error => {
        console.log(error)
        this.loadingClients = false
      })
    },
    getResidentialClients() {
      return new Promise((resolve, reject) => {
        this.loadingResidentialClients = true
        ApiService.get("/client/list", { statuses: ['active']})
          .then(response => {
            let data = response.data;
            this.residentialClients = data.clients;
            this.loadingResidentialClients = false
            resolve()
          })
          .catch(erorr => {
            console.log(error);
            this.loadingResidentialClients = false
            reject()
          });
      })
    },
    getCommercialClients() {
      return new Promise((resolve, reject) => {
        this.loadingCommercialClients = true;
          ApiService.get("/commercial/location/select")
            .then(response => {
              let data = response.data;
              this.commercialClients = data.commercial_locations;
              this.loadingCommercialClients = false;
              resolve()
            })
            .catch(erorr => {
              console.log(error);
              this.loadingResidentialClients = false
              reject()
            });
      })
    },
    getOrganizationSettings(mandatory = false) {
      this.loadingOrganizationSettings = true;
      return new Promise((resolve, reject) => {
      this.checkOrganizationSettings({ mandatory })
        .then(response => {
          if(!this.no_data.includes(response.notifications_disabled)) {
            this.notificationsDisabled = Boolean(Number(response.notifications_disabled))
          } else {
            this.notificationsDisabled = false
          }
          this.loadingOrganizationSettings = false;
          resolve()
        })
        .catch(({ response }) => {
          this.loadingOrganizationSettings = false;
          reject(response)
        });
      })
    },
    resetFilters() {
      this.tableData = {
        date: moment().format("YYYY[-]MM[-]DD"),
        draw: 0,
        length: 10,
        search: "",
        page: 0,
        column: 0,
        dir: "asc"
      }
      this.selectedClient = null
      this.initialize(1)
    },
    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
    },
    formatTime(str) {
      return moment(str).format('hh:mm:ss A')
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    },
    upperFirst(str) {
      return _.upperFirst(str);
    }
  },
  computed: {
    ...mapGetters(['cleanupNotificationsReportTableData']),
    clientList () {
      let residential = _.cloneDeep(this.residentialClients)
      let commercial = _.cloneDeep(this.commercialClients)
      residential = residential.map(i => ({
        ...i,
        type: 'residential',
        title: `${i.first_name} ${i.last_name}`
      }))
      commercial = commercial.map(i => ({
        ...i,
        type: 'commercial',
        title: `${i.commercial_customer_name} - ${i.commercial_location_name}`
      }))
      return [...residential, ...commercial]
    }
  }
};
</script>

<style>
  .cleanup-notifications-report-wrap .clear-filters {
    text-transform: none;
    color: #00838F;
    cursor: pointer;
    text-decoration: underline;
    font-size: 13px;
  }
</style>